<template>
	<li class="accordion__item">
		<div
			class="accordion__trigger"
			:class="{'accordion__trigger_active': visible}"
		>

			<!-- This slot will handle the title/header of the accordion and is the part you click on -->
			<slot name="accordion-trigger"></slot>

			<div class='toggle'>

			</div>

		</div>

		<transition
			name="accordion"
			@enter="start"
			@after-enter="end"
			@before-leave="start"
			@after-leave="end"
		>

			<div
				class="accordion__content"
				:class="{'open': visible}"
				v-show="visible"
			>
				<!-- This slot will handle all the content that is passed to the accordion -->
				<slot name="accordion-content"></slot>
			</div>
		</transition>
	</li>
</template>


<script>
export default {
	props: {},
	inject: ['Accordion'],
	data() {
		return {
			index: null,
		};
	},
	computed: {
		visible() {
			return this.index == this.Accordion.active;
		},
	},
	methods: {
		open() {
			if (this.visible) {
				this.Accordion.active = null;
			} else {
				this.Accordion.active = this.index;
			}
		},
		start(el) {
			el.style.height = el.scrollHeight + 'px';
		},
		end(el) {
			el.style.height = '';
		},
	},
	created() {
		this.index = this.Accordion.count++;
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion {
	&__item {
		position: relative;
		border-radius: 0;
		border-top: var(--border);

		.theme--dark_blue &,
		.theme--white &,
		.theme--none &,
		.benefits_coverage & {
			border-top: 1px solid var(--cobalt);
		}

		&:last-of-type {
			/* border-bottom: var(--border); */

			/* .theme--dark_blue &,
			.theme--white & {
				border-bottom: 1px solid var(--cobalt);
			} */
		}
	}

	&__trigger {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 0 16px;
		gap: 20px;
		transition: 0.2s ease all;
		color: var(--midnight);
		text-indent: 0;

		/* .accordion__item:last-of-type & {
			padding: 16px 0 0;
		} */

		.theme--blue &,
		.theme--dark_blue & {
			color: var(--white);
		}

		.toggle {
			display: flex;

			.coverage-show,
			.coverage-hide {
				display: none;
				margin: 0;
			}
		}

		&:hover {
			cursor: pointer;

			h3 {
				text-decoration: underline;
			}
		}

		h4 {
			margin: 0;
		}

		h5 {
			margin: 0;
			text-transform: capitalize;

			.theme--blue &,
			.theme--dark_blue & {
				color: var(--white);
			}
		}

		// &:hover {
		// 	background: var(--stone);
		// 	transition: 0.2s ease all;
		// }
		/* 
		&_active {
			background: var(--stone);
		} */

		p {
			// text-transform: uppercase;
			max-width: calc(100% - 40px);
			margin: 0;
			color: var(--midnight);
			text-transform: unset;
		}

		svg {
			path {
				fill: var(--midnight);

				.theme--blue & {
					fill: var(--white);
				}

				.theme--dark_blue &,
				.theme--white &,
				.theme--none & {
					fill: var(--cobalt);
				}
			}
		}
	}

	&__content {
		padding: 0 0 0;
		color: var(--midnight);

		&::v-deep {
			a {
				font: normal normal normal 14px/18px var(--primary-font-family) !important;

				&.cta {
					display: inline;
				}
			}

			> p,
			div p {
				margin: 0;
				padding: 0 16px 16px 0;
				color: var(--midnight);
				font: normal normal normal 14px/18px var(--primary-font-family) !important;
				text-indent: 0;

				&:last-of-type {
					margin-bottom: 0;
					font: normal normal normal 14px/18px var(--primary-font-family) !important;
				}

				strong {
					font: normal normal bold 14px/18px var(--primary-font-family) !important;
				}

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);
				}
			}

			> p a {
				color: var(--midnight);
				font: normal normal normal 14px/18px var(--primary-font-family) !important;
				text-indent: 0;

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);
				}

				strong {
					font: normal normal bold 14px/18px var(--primary-font-family) !important;
				}
			}

			p {
				color: var(--midnight);
				font: normal normal normal 14px/18px var(--primary-font-family) !important;
				text-indent: 0;

				.theme--blue &,
				.theme--dark_blue & {
					color: var(--white);
				}

				strong {
					font: normal normal bold 14px/18px var(--primary-font-family) !important;
				}
			}

			ul {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;

				li {
					color: var(--midnight);
					font: normal normal normal 14px/18px var(--primary-font-family) !important;
					list-style-type: disc;

					.theme--blue &,
					.theme--dark_blue & {
						color: var(--white);
					}

					strong {
						font: normal normal bold 14px/18px var(--primary-font-family) !important;
					}

					a {
						color: var(--midnight);
						font: normal normal normal 14px/18px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						.theme--blue &,
						.theme--dark_blue & {
							color: var(--white);
						}

						strong {
							font: normal normal bold 14px/18px var(--primary-font-family) !important;
						}
					}
				}
			}

			ol {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;
				list-style: auto;

				li {
					color: var(--midnight);
					font: normal normal normal 14px/18px var(--primary-font-family) !important;
					list-style-type: disc;

					.theme--blue &,
					.theme--dark_blue & {
						color: var(--white);
					}

					strong {
						font: normal normal bold 14px/18px var(--primary-font-family) !important;
					}

					a {
						color: var(--midnight);
						font: normal normal normal 14px/18px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						.theme--blue &,
						.theme--dark_blue & {
							color: var(--white);
						}

						strong {
							font: normal normal bold 14px/18px var(--primary-font-family) !important;
						}
					}
				}
			}

			.site_button {
				margin-top: 16px;
				margin-left: 0;
			}

			hr {
				margin: 0 16px 16px;
				width: calc(100% - 32px);
			}
		}

		&::v-deep {
			.site_button_secondary {
				margin-bottom: 16px;
				margin-left: 0;

				.theme--blue & {
					border: 1px solid var(--white);
					color: var(--white);

					span {
						color: var(--white);
					}

					svg {
						path {
							stroke: var(--white);
						}
					}

					&:hover {
						background: var(--white);
						border: 1px solid var(--white);
						color: var(--midnight);

						span {
							color: var(--midnight);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}

				.theme--dark_blue & {
					border: 1px solid var(--white);
					color: var(--white);

					span {
						color: var(--white);
					}

					svg {
						path {
							stroke: var(--white);
						}
					}

					&:hover {
						border: 1px solid var(--white);
						background: var(--white);
						color: var(--midnight);

						span {
							color: var(--midnight);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}

				.theme--white &,
				.theme--none & {
					border: 1px solid var(--midnight);
					color: var(--midnight);

					span {
						color: var(--midnight);
					}

					svg {
						path {
							stroke: var(--cobalt);
						}
					}

					&:hover {
						border: 1px solid var(--midnight);
						background: var(--midnight);
						color: var(--white);

						span {
							color: var(--white);
						}

						svg {
							path {
								stroke: var(--cobalt);
							}
						}
					}
				}
			}
		}

		&::v-deep {
			.benefit_sub_question__accordion-trigger {
				h5 {
					margin: 0 0 8px;
				}
			}
		}
	}

	&::v-deep {
		.tier_one {
			margin-bottom: 40px;
		}
	}
}

.accordion-enter-active,
.accordion-leave-active {
	will-change: height, opacity, padding-bottom;
	transition: height 0.3s ease, opacity 0.3s ease, padding-bottom 0.3s ease;
	overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
	height: 0 !important;
	opacity: 0;
	padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionItemDisabled.vue